import { InputText } from '@teo/components';
import { Location } from '@teo/components/icons';
import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const MapLocation = ({
  setLocationStr,
  locationStr,
  handleChangeTraining,
  trainingDetail,
}) => {
  const { t } = useTranslation();
  const [map, setMap] = useState();
  const [marker, setMareker] = useState();

  const [mapPosition, setMapPosition] = useState({
    lat: trainingDetail?.locationLatitude
      ? trainingDetail?.locationLatitude
      : 51.19,
    lng: trainingDetail?.locationLongitude
      ? trainingDetail?.locationLongitude
      : 4.45,
  });

  useEffect(() => {
    if (!map && mapPosition) {
      const newMap = new window.google.maps.Map(
        document.getElementById('map'),
        {
          zoom: 15,
          center: mapPosition,
          disableDefaultUI: true,
        }
      );
      setMap(newMap);
    }
    const newMarker = new window.google.maps.Marker({
      position: mapPosition,
      map,
    });
    setMareker(newMarker);
  }, [map]);

  const autocomplete = (e) => {
    setLocationStr(e.target.value);
    const autoComplete = new window.google.maps.places.Autocomplete(
      e.currentTarget
    );
    autoComplete.addListener('place_changed', () => {
      const place = autoComplete.getPlace();
      if (!place.geometry || !place.geometry.location) {
        // alert('this location not available');
      }
      if (place.geometry.viewport || place.geometry.location) {
        if (map) {
          map.setCenter(place.geometry.location);
          marker && marker.setPosition(place.geometry.location);
          setMapPosition(place.geometry.location);
          setLocationStr(place.formatted_address);

          const changes = {};
          if (place.formatted_address !== trainingDetail?.location) {
            changes.location = place.formatted_address;
          }
          if (
            place?.geometry?.location.lng() !==
            trainingDetail?.locationLongitude
          ) {
            changes.locationLongitude = place?.geometry?.location.lng();
          }
          if (
            place?.geometry?.location.lat() !== trainingDetail?.locationLatitude
          ) {
            changes.locationLatitude = place?.geometry?.location.lat();
          }

          handleChangeTraining(changes);
        }
      }
    });
  };
  return (
    <>
      <div className="mb-1 mt-6 w-full text-sm font-semibold text-black">
        <label className="mb-1 block text-sm font-semibold text-black">
          {t('pages.learning_path.settings.location')}
        </label>
        <InputText
          Icon={Location}
          onChange={(e) => {
            autocomplete(e);
          }}
          placeholder={t(`pages.onboarding.step_2.placeholder`)}
          value={locationStr}
          className="mb-2"
        />
      </div>
      <div
        className="rounded-lg"
        style={{ width: '100%', height: 250 }}
        id="map"
      />
    </>
  );
};

export default MapLocation;
